import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const mapyAvatarCss = ":host{display:inline-block;border-radius:50%;border:2px solid #ffffff;color:#6f8ff7}:host([size=\"24\"]){width:24px;height:24px}:host([size=\"32\"]){width:32px;height:32px}:host([size=\"36\"]){width:36px;height:36px}:host(:not([size])),:host([size=\"40\"]){width:40px;height:40px}:host([size=\"48\"]){width:48px;height:48px}:host([size=\"56\"]){width:56px;height:56px}:host([size=\"64\"]){width:64px;height:64px}:host([selected]){border-color:#6f8ff7}:host([inactive]) ::slotted(*){filter:grayscale(1)}.wrapper{position:relative;width:100%;height:100%}::slotted(*){display:block;width:100%;height:100%;object-fit:cover;border-radius:50%}:host(:not([azimuth])) svg{display:none}:host svg{--azimuth:0deg;fill:currentColor;position:absolute;left:50%;top:50%;translate:-50% -50%;transform-origin:50% 50%;transform:rotate(var(--azimuth, 0)) translate(-207.14286%, 0%);width:35%;height:42.5%}:host .premium{position:absolute;width:18px;height:18px;top:-1px;left:-5px}:host([size=\"24\"]) .premium{width:14px;height:14px;left:-6px}:host([size=\"32\"]) .premium{width:14px;height:14px}:host([size=\"36\"]) .premium{width:14px;height:14px}:host([size=\"64\"]) .premium{left:-9.5px;top:-5.5px;width:27px;height:27px}";

const svgSBR = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
	<circle cx="9" cy="9" r="8.5" fill="url(#paint0_linear_7496_1537)" stroke="white"/>
	<path d="M12.4598 12.6667C13.1445 12.6667 13.7185 12.148 13.7858 11.466L14.3332 6.00004L12.3332 7.33337C12.3332 7.33337 12.9998 8.00004 12.9998 8.66671C12.9998 9.33337 12.5938 10 11.6665 10C10.7385 10 10.3332 9.33337 10.3332 8.66671C10.3332 8.00004 10.9998 7.33337 10.9998 7.33337L8.99984 5.33337L6.99984 7.33337C6.99984 7.33337 7.6665 8.00004 7.6665 8.66671C7.6665 9.33337 7.2605 10 6.33317 10C5.40517 10 4.99984 9.33337 4.99984 8.66671C4.99984 8.00004 5.6665 7.33337 5.6665 7.33337L3.6665 6.00004L4.2125 11.466C4.28117 12.148 4.8545 12.6667 5.53984 12.6667H12.4598Z" fill="white"/>
	<defs>
		<linearGradient id="paint0_linear_7496_1537" x1="9" y1="17" x2="9" y2="1" gradientUnits="userSpaceOnUse">
			<stop stop-color="#DD9721"/>
			<stop offset="1" stop-color="#F9E099"/>
		</linearGradient>
	</defs>
</svg>`;
const blobSBR = new Blob([svgSBR], { type: 'image/svg+xml' });
const urlSBR = URL.createObjectURL(blobSBR);
const svgMapy = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
	<rect x="0.5" y="0.5" width="17" height="17" rx="8.5" fill="url(#paint0_linear_2914_25759)"/>
	<rect x="0.5" y="0.5" width="17" height="17" rx="8.5" stroke="white"/>
	<g clip-path="url(#clip0_2914_25759)">
		<path d="M13.1378 11.5518C13.7755 11.3809 14.1807 10.7545 14.0732 10.1025L13.2188 4.87471L11.6887 6.61576C11.6887 6.61576 12.4761 7.07033 12.6424 7.69128C12.8088 8.31224 12.597 9.03452 11.7333 9.26596C10.8689 9.49756 10.325 8.97777 10.1586 8.35682C9.99225 7.73587 10.4468 6.94853 10.4468 6.94853L8.08481 5.58482L6.7211 7.94683C6.7211 7.94683 7.50844 8.4014 7.67482 9.02235C7.8412 9.64331 7.62943 10.3656 6.76568 10.597C5.90132 10.8286 5.35739 10.3088 5.19101 9.68789C5.02463 9.06694 5.4792 8.2796 5.4792 8.2796L3.28357 7.53685L5.15631 12.4918C5.39048 13.1099 6.05394 13.4499 6.69228 13.2788L13.1378 11.5518Z" fill="white"/>
	</g>
	<defs>
		<linearGradient id="paint0_linear_2914_25759" x1="9" y1="1" x2="9" y2="17" gradientUnits="userSpaceOnUse">
			<stop stop-color="#34D313"/>
			<stop offset="1" stop-color="#1EAE00"/>
		</linearGradient>
		<clipPath id="clip0_2914_25759">
			<rect width="10.2857" height="10.2857" fill="white" transform="translate(2.70117 5.36353) rotate(-15)"/>
		</clipPath>
	</defs>
</svg>`;
const blobMapy = new Blob([svgMapy], { type: 'image/svg+xml' });
const urlMapy = URL.createObjectURL(blobMapy);
const MapyAvatar$1 = /*@__PURE__*/ proxyCustomElement(class MapyAvatar extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.inactive = false;
    this.selected = false;
    this.azimuth = NaN;
    this.premium = 'none';
    this.size = 40;
  }
  render() {
    return (h(Host, null, h("div", { class: "wrapper" }, h("slot", null), isNaN(this.azimuth)
      ? null
      : h("svg", { viewBox: "0 0 14 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: { '--azimuth': `${this.azimuth + 90}deg` } }, h("path", { d: "M13.5329 0.0839844L0 8.5416L13.5328 17C12.542 14.3695 12 11.5191 12 8.5421C12 5.56502 12.5421 2.71454 13.5329 0.0839844Z", fill: "#6F8FF7" })), this.premium === 'none'
      ? null
      : h("img", { src: this.premium === 'sbr'
          ? urlSBR
          : urlMapy, role: "presentation", class: "premium" }))));
  }
  static get style() { return mapyAvatarCss; }
}, [1, "mapy-avatar", {
    "inactive": [516],
    "selected": [516],
    "azimuth": [514],
    "premium": [513],
    "size": [514]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["mapy-avatar"];
  components.forEach(tagName => { switch (tagName) {
    case "mapy-avatar":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, MapyAvatar$1);
      }
      break;
  } });
}
defineCustomElement$1();

const MapyAvatar = MapyAvatar$1;
const defineCustomElement = defineCustomElement$1;

export { MapyAvatar, defineCustomElement };

//# sourceMappingURL=mapy-avatar.js.map